<nb-card *ngIf="syncLive" [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-card-header *ngIf="mode === 'categories'">
    <!-- <button
      nbButton
      outline
      shape="semi-round"
      status="success"
      size="small"
      (click)="printProducts()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      <span>{{ "buttons.printProducts" | translate }}</span>
    </button> -->

    <button
      *ngIf="user?.admin || user?.moderator"
      nbButton
      ghost
      shape="semi-round"
      status="danger"
      size="small"
      (click)="syncProduct()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
    >
      <nb-icon icon="sync-outline"></nb-icon>
      Đồng bộ dữ liệu
    </button>
  </nb-card-header>

  <nb-card-body>
    <div class="table-responsive">
      <table class="table align-items-center table-striped">
        <thead class="thead-light">
          <tr>
            <th scope="col">Mã hàng</th>
            <th scope="col">Tên hàng</th>
            <th scope="col">ĐVT</th>
            <th scope="col">Giá bán</th>
            <th>
              <nb-select
                outline
                shape="round"
                size="small"
                status="info"
                class="period-select"
                [(ngModel)]="specParams.sort"
                (selectedChange)="getPaginationProduct()"
                placeholder="Sắp xếp"
              >
                <nb-option value="titleAsc">Tên (A-Z)</nb-option>
                <nb-option value="titleDesc">Tên (Z-A)</nb-option>
                <nb-option value="timestampDesc">Mới nhất </nb-option>
                <nb-option value="timestampAsc">Cũ nhất</nb-option>
              </nb-select>
            </th>
          </tr>
          <tr>
            <td colspan="5">
              <div class="form-inline">
                <nb-form-field fullWidth>
                  <nb-icon nbPrefix icon="search-outline"></nb-icon>
                  <input
                    type="text"
                    nbInput
                    fullWidth
                    shape="semi-round"
                    class="form-control"
                    placeholder="{{ 'common.strSearch' | translate }}"
                    [(ngModel)]="specParams.search"
                    (keydown.enter)="search()"
                    #strSearch
                  />
                </nb-form-field>
                <button
                  nbButton
                  outline
                  shape="semi-round"
                  status="primary"
                  size="small"
                  (click)="onNew()"
                  [disabled]="loading"
                  [class.btn-pulse]="loading"
                >
                  <span>{{ "buttons.create" | translate }}</span>
                </button>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of paginationProduct.data">
            <td>
              {{ item.barcode }}
            </td>
            <td>
              <a (click)="edit(item)" class="text-link link">
                {{
                  item.title.length > 50
                    ? item.title.substring(0, 50) + "..."
                    : item.title
                }}
              </a>
            </td>
            <td>
              {{ item.unitName }}
            </td>
            <td>
              <span *ngIf="mode === 'receipt'"> {{ item.price | number }}</span>
              <span *ngIf="mode === 'purchase'">
                {{ item.costPrice | number }}</span
              >
            </td>
            <td>
              <button
                nbButton
                ghost
                status="danger"
                size="small"
                [disabled]="submitted"
                [class.btn-pulse]="submitted"
                (click)="delete(item)"
              >
                <nb-icon icon="trash-2-outline"></nb-icon>
              </button>

              <button
                nbButton
                ghost
                status="info"
                size="small"
                [disabled]="submitted"
                [class.btn-pulse]="submitted"
                (click)="edit(item)"
              >
                <nb-icon icon="edit-2-outline"></nb-icon>
              </button>

              <button
                *ngIf="mode === 'receipt' || mode === 'purchase'"
                nbButton
                shape="round"
                outline
                status="success"
                size="medium"
                [disabled]="submitted"
                [class.btn-pulse]="submitted"
                (click)="selected(item)"
              >
                <nb-icon icon="checkmark-outline"></nb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </nb-card-body>
  <nb-card-footer *ngIf="paginationProduct.count > paginationProduct.pageSize">
    <nav aria-label="Page navigation example">
      <ul class="pagination justify-content-end">
        <li
          [ngClass]="
            specParams.pageIndex === 1 ? 'page-item active' : 'page-item'
          "
        >
          <a class="page-link" (click)="pageChanged(1)">1</a>
        </li>

        <li
          [ngClass]="
            specParams.pageIndex === 1 ? 'page-item disabled' : 'page-item'
          "
        >
          <a class="page-link" aria-label="Previous" (click)="pagePrevious()">
            <span aria-hidden="true">&laquo;</span>
            <span class="sr-only">Trang trước</span>
          </a>
        </li>

        <li *ngIf="paginationProduct.pageIndex - 1 > 1" class="page-item">
          <a
            class="page-link"
            (click)="pageChanged(paginationProduct.pageIndex - 1)"
          >
            {{ paginationProduct.pageIndex - 1 }}
          </a>
        </li>

        <li
          *ngIf="
            paginationProduct.pageIndex !== 1 &&
            paginationProduct.pageIndex != paginationProduct.totalPages
          "
          class="page-item active"
        >
          <a class="page-link">
            {{ paginationProduct.pageIndex }}
          </a>
        </li>

        <li
          *ngIf="paginationProduct.pageIndex + 1 < paginationProduct.totalPages"
          class="page-item"
        >
          <a
            class="page-link"
            (click)="pageChanged(paginationProduct.pageIndex + 1)"
          >
            {{ paginationProduct.pageIndex + 1 }}
          </a>
        </li>

        <li
          [ngClass]="
            specParams.pageIndex === paginationProduct.totalPages
              ? 'page-item disabled'
              : 'page-item'
          "
        >
          <a class="page-link" aria-label="Next" (click)="pageNext()">
            <span aria-hidden="true">&raquo;</span>
            <span class="sr-only">Trang kế</span>
          </a>
        </li>

        <li
          [ngClass]="
            specParams.pageIndex === paginationProduct.totalPages
              ? 'page-item active'
              : 'page-item'
          "
        >
          <a
            class="page-link"
            (click)="pageChanged(paginationProduct.totalPages)"
          >
            {{ paginationProduct.totalPages }}
          </a>
        </li>
      </ul>
    </nav>
  </nb-card-footer>
</nb-card>
